import { defineMessages } from 'react-intl'

export default defineMessages({
  download: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.download',
    defaultMessage: 'Download',
  },
  downloadAll: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.downloadAll',
    defaultMessage: 'Download ZIP'
  },
  revised: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.revised',
    defaultMessage: 'Revised'
  },
  accept: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.accept',
    defaultMessage: 'Approve recordings'
  },
  decline: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.decline',
    defaultMessage: 'Reject'
  },
  feedbackMessage: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.feedbackMessage',
    defaultMessage: 'Enter feedback (required on rejection)',
  },
  loading: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.feedback.loading',
    defaultMessage: 'Loading',
  },
  submit: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.feedback.submit',
    defaultMessage: 'Submit',
  },
  feedbackMessageSent :{
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.Delivery.feedbackMessageSent',
    defaultMessage: 'Your feedback has been sent',
  },
})
